import { Decoder, Encoder } from '@iotize/common/converter/api';

import { ConverterError } from './error';
import { TapStreamReader, TapStreamWriter } from '../frame/tap-stream-extended';
import { createTapEncryptedFrame } from '../model/models.extensions';

export interface CryptoFrameIdGenerator {
  next(): number;
}
/**
 *
 */
export class CryptedFrameConverter
  implements Encoder<Uint8Array, Uint8Array>, Decoder<Uint8Array, Uint8Array>
{
  // public paddingGenerator? : (size: number) => Uint8Array;
  public frameIdGenerator: CryptoFrameIdGenerator;

  constructor(frameIdGenerator: CryptoFrameIdGenerator) {
    this.frameIdGenerator = frameIdGenerator;
  }

  encode(data: Uint8Array): Uint8Array {
    const encryptedModel = createTapEncryptedFrame(
      this.frameIdGenerator.next(),
      data,
      // this.paddingGenerator
    );
    return new TapStreamWriter().writeTapEncryptedFrame(encryptedModel).toBytes;
  }

  decode(frame: Uint8Array): Uint8Array {
    if (!frame) {
      throw ConverterError.nullBufferError('Illegal data: frame is null');
    }
    const encryptedFrame =
      TapStreamReader.fromArray(frame).readTapEncryptedFrame();
    const subData = encryptedFrame.payload;

    // TODO add back crc
    // let crc = encryptedFrame.crc;
    // let computedCrc = this._computeCRC(byteBuffer.data);

    // if (crc != computedCrc){
    //     if (this.options.skipCRCCheck){
    //     }
    //     else{
    //         throw new Error(`Invalid crc read ${crc}. Should be ${computedCrc}`);
    //     }
    // }
    return subData;
  }
}
